import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Grid, { GridProps } from "@material-ui/core/Grid"

const useStyles = makeStyles({
    "@keyframes fadeIn": {
        "0%": {
            opacity: 0,
            transform: "translateY(-10px)",
        },
        "100%": {
            opacity: 100,
            transform: "translateY(0)",
        },
    },
    animate: {
        animation: `$fadeIn 200ms`,
        flexBasis: "auto !important",
    },
})

export default function FadeInGrid({ className, ...rest }: GridProps) {
    const classes = useStyles()
    const c = className ? `${className} ${classes.animate}` : classes.animate

    return <Grid container item direction="column" xs className={c} {...rest} />
}
